"use client";

import React from "react";
import Image from "next/image";
import * as Icon from "@phosphor-icons/react/dist/ssr";
import { Tag } from "antd";
import moment from "moment/moment";
import { useTranslations } from "next-intl";
import { type Blog } from "@/lib/@types/api/blog";
import { Link } from "@/navigation";
import { replaceImgUrl } from "@/lib/utils.ts";

interface BlogProps {
	news: Blog.BlogListItem;
	/** 博客列表首屏前几张图片使用 priority，提升 LCP */
	priority?: boolean;
}

const BlogItemDefault: React.FC<BlogProps> = ({ news, priority = false }) => {
	const t = useTranslations("blog");
	return (
		<>
			<Link
				href={"/blog/" + news.blog_slug}
				className="block transform cursor-pointer overflow-hidden rounded-lg bg-white shadow-lg transition-all duration-700 hover:-translate-y-2 hover:shadow-[#a8b7d2]"
			>
				{/* 封面统一 640×427（约 3:2），用比例容器 + fill 避免正方形拉伸 */}
				<div className="relative aspect-[640/427] w-full overflow-hidden bg-gray-100">
					<Image
						src={replaceImgUrl(news.blog_cover_origin)}
						alt={news.blog_title}
						fill
						className="object-fill"
						sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, (max-width: 1600px) 33vw, 25vw"
						loading={priority ? "eager" : "lazy"}
						priority={priority}
					/>
				</div>
				<div className="px-4 py-6">
					<div className="flex gap-x-1 overflow-hidden">
						{news.blog_classification_list &&
							news.blog_classification_list.map((item) => {
								return (
									<Tag color="" className="text-xs uppercase" key={item.cls_slug}>
										{item.cls_name}
									</Tag>
								);
							})}
					</div>
					<h3 className="my-2 line-clamp-2 h-14 !text-xl font-bold text-black">{news.blog_title}</h3>
					<p className="my-2 line-clamp-2 text-xs font-normal text-[#677E6E] max-md:my-1 sm:text-sm">
						{news.blog_excerpt}
					</p>
					<div className="mt-5 flex items-center justify-between gap-x-1 !text-xs text-gray-500">
						<div>
							<span className="inline-flex h-6 w-6 shrink-0 overflow-hidden rounded">
								<img src="/image/logo1.png" alt="" className="h-full w-full object-fill" />
							</span>
							<span className="ml-2 text-[1rem]">{t("authorName")}</span>
						</div>
						<div>
							<div className="flex items-center gap-1 text-[1rem]">
								<Icon.Calendar size={16} />
								{moment(news.blog_upload_time).format("MMM DD YYYY")}
							</div>
						</div>
					</div>
					{/*<span  className="text-black text-xs hover:text-main">READ MORE</span>*/}
				</div>
			</Link>
		</>
	);
};

export default BlogItemDefault;
